// 9 agents — escouade DNCM Vision (Selena, Eva, Athena, Atlas, Clara, Vega, Lexa, Sofia, Lena)
// All prices are stored in PHP (base) and converted dynamically by I18nContext.

export const AGENTS = [
  {
    id: "selena",
    name: "Selena",
    role: "Orchestration stratégique",
    tagline: "Cheffe d'orchestre du système",
    short:
      "Coordonne les autres agents et garantit que chaque tâche atteint la bonne destination, au bon moment.",
    long:
      "Selena supervise l'ensemble de l'équipe d'agents. Elle priorise les requêtes, assigne le bon spécialiste et veille à la cohérence des actions.",
    capacities: [
      "Routage intelligent des demandes",
      "Priorisation et arbitrages",
      "Cohérence multi-agents",
      "Reporting consolidé",
    ],
    chatbot: {
      intro: "Bonjour, je suis Selena. Décrivez votre besoin, je m'occupe d'orchestrer la suite.",
      examples: ["Coordonner une campagne", "Prioriser 3 demandes", "Suivi global"],
      scripted: {
        default:
          "Demande prise. Je dispatch vers Athena (analyse) et Atlas (closing). Suivi en place.",
        coord: "Campagne orchestrée : brief, créa, ciblage, diffusion, mesure. Tous les agents alignés.",
        prio: "Priorisation : urgent #1 → Atlas, #2 → Clara (client critique), #3 → Eva.",
        suivi: "Tableau de bord à jour : 4 tâches actives, 2 en attente, 0 en retard.",
      },
    },
    price_php: 9500,
    color: "#00cfff",
    accent: "cyan",
    icon: "Compass",
    initial: "S",
    roi: { multiplier: 3.6, baseLeadsPerMonth: 0, descriptor: "Coordination" },
    voice: true,
  },{
    id: "athena",
    name: "Athena",
    role: "Analyse marketing",
    tagline: "Comprend vos données et anticipe",
    short:
      "Analyse vos chiffres, détecte les tendances et propose des décisions claires basées sur des faits.",
    long:
      "Athena scrute vos performances, identifie les signaux faibles et restitue des recommandations stratégiques compréhensibles, sans jargon.",
    capacities: [
      "Étude de marché continue",
      "A/B testing automatique",
      "Détection de tendances",
      "Rapports limpides",
    ],
    chatbot: {
      intro: "Athena, stratège. Donnez-moi vos chiffres, je trouve l'angle qui manque.",
      examples: ["Analyser une cohorte", "Concevoir une campagne", "Trouver un levier caché"],
      scripted: {
        default: "Tendance détectée : panier moyen +6.4%, cohorte 25-34 surperforme de 11%.",
        cohorte: "Votre cohorte hiver a une rétention 2.1× supérieure. Budget à réallouer.",
        leverage: "Levier caché : 31% du revenu provient des commandes du dimanche. Bundle dédié à pousser.",
      },
    },
    price_php: 9500,
    color: "#deff9a",
    accent: "green",
    icon: "LineChart",
    initial: "A",
    roi: { multiplier: 1.0, baseLeadsPerMonth: 80, descriptor: "Insights" },
  },
  {
    id: "atlas",
    name: "Atlas",
    role: "Vente",
    tagline: "Convertit l'attention en revenus",
    short:
      "Qualifie vos prospects, les nourrit et les guide vers la décision d'achat avec finesse.",
    long:
      "Atlas accompagne chaque opportunité : prise de contact, argumentaire personnalisé, relance intelligente, transmission au bon moment.",
    capacities: [
      "Scoring d'intention en continu",
      "Pitch personnalisé",
      "Relance multi-canaux",
      "Passage de relais aux commerciaux",
    ],
    chatbot: {
      intro: "Atlas à votre service. Parlez-moi de votre cible — je construis un plan d'acquisition.",
      examples: ["Qualifier un lead entrant", "Créer un pitch à chaud", "Relancer un prospect froid"],
      scripted: {
        default: "Lead qualifié : score 0.84. Proposition d'appel envoyée dans les 5 minutes.",
        pitch: "Pitch prêt : accroche émotionnelle, bénéfice chiffré, preuve sociale, CTA clair.",
        relance: "Relance tendre programmée sur 3 touches (J+2, J+5, J+10).",
      },
    },
    price_php: 9500,
    color: "#34d399",
    accent: "green",
    icon: "Target",
    initial: "A",
    roi: { multiplier: 1.0, baseLeadsPerMonth: 220, descriptor: "Closing" },
    voice: true,
  },
  {
    id: "clara",
    name: "Clara",
    role: "Relation client",
    tagline: "L'écoute incarnée, à grande échelle",
    short:
      "Répond à vos clients avec empathie, instantanément, dans plusieurs langues, sans jamais perdre patience.",
    long:
      "Clara assure un service client premium : réponses immédiates, ton humain, escalade automatique vers vos équipes lorsque nécessaire.",
    capacities: [
      "Réponse immédiate 24/7",
      "Ton humain, multilingue",
      "Escalade intelligente",
      "Mémoire client persistante",
    ],
    chatbot: {
      intro: "Clara, bonjour ! Comment puis-je vous aider aujourd'hui ?",
      examples: ["Suivre une commande", "Gérer un litige", "Répondre en 3 langues"],
      scripted: {
        default: "Dossier identifié, livraison prévue demain 10h-12h. Geste de compensation envoyé.",
        litige: "Situation désamorcée, solution proposée (remboursement partiel + cadeau).",
        langue: "Réponse adaptée : ES pour le 1er, FR pour le 2ème, EN pour le 3ème — en 4s.",
      },
    },
    price_php: 6000,
    color: "#fb7185",
    accent: "cyan",
    icon: "MessageCircleHeart",
    initial: "C",
    roi: { multiplier: 1.0, baseLeadsPerMonth: 60, descriptor: "Rétention" },
  },
  {
    id: "vega",
    name: "Vega",
    role: "Création visuelle",
    tagline: "L'imagination opérationnelle",
    short:
      "Produit textes, visuels, scripts et idées de campagnes alignés avec votre univers de marque.",
    long:
      "Vega imagine, rédige et décline vos contenus : posts, articles, accroches, visuels conceptuels, le tout en cohérence avec votre identité.",
    capacities: [
      "Copywriting et accroches",
      "Visuels conceptuels",
      "Déclinaisons multi-formats",
      "Cohérence de marque",
    ],
    chatbot: {
      intro: "Vega ici. Parlez-moi de votre marque — je produis la matière qui parle vraiment.",
      examples: ["6 accroches pour une promo", "Moodboard d'une campagne", "Storyboard 30s"],
      scripted: {
        default: "6 accroches livrées, 3 émotionnelles, 3 orientées bénéfice. Deux pistes percutantes.",
        moodboard: "Moodboard 9 visuels : palette chaude, textures organiques, énergie douce.",
        story: "Storyboard 30s : accroche 3s, problème 8s, solution 12s, preuve 4s, CTA 3s.",
      },
    },
    price_php: 6500,
    color: "#f59e0b",
    accent: "cyan",
    icon: "Sparkles",
    initial: "V",
    roi: { multiplier: 1.0, baseLeadsPerMonth: 40, descriptor: "Engagement" },
  },
  {
    id: "lexa",
    name: "Lexa",
    role: "Juridique",
    tagline: "Le réflexe conformité",
    short:
      "Vérifie, encadre et sécurise vos documents et processus selon les bonnes pratiques juridiques.",
    long:
      "Lexa relit vos contrats, conditions et communications sensibles. Elle alerte sur les zones de risque et propose des reformulations claires.",
    capacities: [
      "Relecture de contrats & CGU",
      "Vérification RGPD / privacy",
      "Alerte clauses à risque",
      "Mise en conformité progressive",
    ],
    chatbot: {
      intro: "Lexa. Un document à sécuriser ? Collez-en un extrait, je surligne les zones sensibles.",
      examples: ["Relire un contrat", "Vérifier RGPD", "Reformuler une clause"],
      scripted: {
        default: "3 clauses ambiguës détectées, 2 à reformuler, 1 à supprimer.",
        rgpd: "Privacy : collecte OK, base légale à préciser, durée de conservation à clarifier.",
        reform: "Reformulation proposée — plus claire, plus courte, sans perte de protection.",
      },
    },
    price_php: 8000,
    color: "#e0e7ff",
    accent: "cyan",
    icon: "Scale",
    initial: "L",
    roi: { multiplier: 1.0, baseLeadsPerMonth: 0, descriptor: "Sécurité" },
  },
  {
    id: "sofia",
    name: "Sofia",
    role: "Support",
    tagline: "Le soutien permanent de vos clients",
    short:
      "Résout les demandes courantes, oriente les cas sensibles et garde vos clients sereins, jour et nuit.",
    long:
      "Sofia accueille les demandes entrantes, qualifie le besoin, propose une résolution immédiate ou oriente intelligemment.",
    capacities: [
      "Résolution immédiate",
      "Routage intelligent",
      "Suivi de tickets",
      "Mémoire de la relation",
    ],
    chatbot: {
      intro: "Sofia, je vous écoute. Quel est votre souci ?",
      examples: ["Question fréquente", "Cas sensible", "Suivi de ticket"],
      scripted: {
        default: "Réponse envoyée. Si vous avez un autre détail, je reformule à votre place.",
        sensible: "Cas escaladé à votre équipe avec contexte complet et suggestion de réponse.",
        suivi: "Ticket #C-7741 résolu en 12s. Satisfaction : 5/5.",
      },
    },
    price_php: 6500,
    color: "#22d3ee",
    accent: "cyan",
    icon: "Headphones",
    initial: "S",
    roi: { multiplier: 1.0, baseLeadsPerMonth: 0, descriptor: "Support" },
  },
  {
    id: "lena",
    name: "Lena",
    role: "Réseaux sociaux",
    tagline: "Votre présence sociale, en pilote automatique",
    short:
      "Publie, anime et observe vos communautés sur les bons formats, aux bons moments, avec la bonne tonalité.",
    long:
      "Lena programme et publie vos contenus, répond aux commentaires, surveille les tendances et adapte le ton à chaque réseau.",
    capacities: [
      "Calendrier éditorial",
      "Modération en temps réel",
      "Veille des tendances",
      "Adaptation par plateforme",
    ],
    chatbot: {
      intro: "Lena prête. On parle de quel réseau et de quel angle ?",
      examples: ["Plan éditorial 14j", "Modérer un commentaire", "Détecter une tendance"],
      scripted: {
        default: "Plan éditorial : 9 posts sur 3 réseaux, ton ajusté par plateforme. Approbation ?",
        moderation: "Réponse polie et claire envoyée. Je tiens un journal des cas escaladés.",
        tendance: "Tendance émergente détectée — opportunité d'angle créatif sous 48h.",
      },
    },
    price_php: 7000,
    color: "#f472b6",
    accent: "cyan",
    icon: "Share2",
    initial: "L",
    roi: { multiplier: 1.0, baseLeadsPerMonth: 90, descriptor: "Audience" },
  },
  {
    id: "jade",
    name: "Jade",
    role: "Voyages & Tourisme",
    tagline: "Votre expert voyage disponible 24h/24",
    short: "Planifie, réserve et optimise chaque déplacement professionnel ou touristique avec précision.",
    long: "Jade gère les itinéraires complexes, compare les offres en temps réel, anticipe les imprévus et assure un voyage sans friction de A à Z.",
    capacities: [
      "Planification d'itinéraires",
      "Comparaison tarifaire temps réel",
      "Gestion des imprévus",
      "Support multilingue voyage",
    ],
    chatbot: {
      intro: "Jade prête. Quelle est votre prochaine destination ?",
      examples: ["Planifier un séjour Bali 10j", "Vol + hôtel Manila", "Budget voyage Europe"],
      scripted: {
        default: "Itinéraire optimisé : vols, hôtels, transferts. Budget estimé transmis pour validation.",
        sejour: "Séjour planifié : 3 hôtels sélectionnés, activités recommandées, budget détaillé prêt.",
        budget: "Analyse tarifaire complète. Option économique vs confort identifiées. Quelle priorité ?",
      },
    },
    price_php: 8500,
    color: "#34d399",
    accent: "cyan",
    icon: "Plane",
    initial: "J",
    roi: { multiplier: 2.8, baseLeadsPerMonth: 60, descriptor: "Voyages" },
    voice: true,
  },
  {
    id: "aria",
    name: "Aria",
    role: "Finance & Paiements",
    tagline: "Votre hub financier intelligent",
    short: "Centralise les flux financiers, automatise les relances et sécurise chaque transaction.",
    long: "Aria surveille la trésorerie, génère les rapports financiers, gère les relances clients et coordonne les paiements multi-devises en temps réel.",
    capacities: [
      "Suivi trésorerie temps réel",
      "Relances automatiques",
      "Rapports financiers",
      "Paiements multi-devises",
    ],
    chatbot: {
      intro: "Aria connectée. Quel flux financier dois-je surveiller ?",
      examples: ["État de trésorerie", "Relancer factures impayées", "Rapport mensuel"],
      scripted: {
        default: "Flux analysés. 3 factures en retard détectées. Relances automatiques programmées.",
        tresorerie: "Trésorerie actuelle : solde positif, 2 échéances à 7 jours. Alerte configurée.",
        rapport: "Rapport mensuel généré : revenus, dépenses, marge nette. Export PDF disponible.",
      },
    },
    price_php: 9000,
    color: "#fbbf24",
    accent: "cyan",
    icon: "TrendingUp",
    initial: "A",
    roi: { multiplier: 3.2, baseLeadsPerMonth: 0, descriptor: "Finance" },
  },
  {
    id: "nova",
    name: "Nova",
    role: "Standardiste vocale IA",
    tagline: "Votre accueil téléphonique intelligent",
    short:
      "Répond, qualifie et oriente chaque appel entrant en moins de 3 secondes, 24h/24, sans file d'attente.",
    long:
      "Nova prend en charge tous vos appels entrants : accueil personnalisé, qualification du besoin, orientation vers le bon interlocuteur ou prise de message structurée. Elle parle naturellement et ne fait jamais attendre.",
    capacities: [
      "Accueil vocal 24h/24",
      "Qualification instantanée",
      "Orientation multi-agents",
      "Prise de message structurée",
    ],
    chatbot: {
      intro: "Nova à l'écoute. Comment puis-je vous orienter ?",
      examples: ["Tester l'accueil vocal", "Simuler un appel entrant", "Configurer les réponses"],
      scripted: {
        default: "Appel reçu, besoin qualifié, transmission à l'expert en 3 secondes. File d'attente : zéro.",
        accueil: "Bonjour, vous êtes bien chez [votre entreprise]. Je vous mets en relation avec le bon interlocuteur.",
        config: "Scripts personnalisés configurés : horaires, langues, escalades. Opérationnel en 24h.",
      },
    },
    price_php: 9500,
    color: "#a78bfa",
    accent: "violet",
    icon: "Mic",
    initial: "N",
    roi: { multiplier: 4.2, baseLeadsPerMonth: 120, descriptor: "Appels traités" },
    voice: true,
  },
  {
    id: "neo",
    name: "Neo",
    role: "Support Tech",
    tagline: "Votre technicien IA disponible en permanence",
    short: "Diagnostique, résout et documente chaque incident technique avec rapidité et précision.",
    long: "Neo prend en charge le support technique de premier niveau, escalade les cas complexes, maintient la base de connaissance et réduit le temps de résolution.",
    capacities: [
      "Diagnostic incidents en temps réel",
      "Base de connaissance dynamique",
      "Escalade intelligente",
      "Reporting technique",
    ],
    chatbot: {
      intro: "Neo en ligne. Quel problème technique puis-je résoudre ?",
      examples: ["Diagnostic connexion", "Erreur système", "Mise à jour documentation"],
      scripted: {
        default: "Incident diagnostiqué. Solution identifiée en base de connaissance. Application en cours.",
        diagnostic: "Analyse complète : origine identifiée, correctif appliqué, test de validation OK.",
        doc: "Documentation mise à jour. Cas ajouté à la base pour prévention future.",
      },
    },
    price_php: 7500,
    color: "#a78bfa",
    accent: "cyan",
    icon: "Cpu",
    initial: "N",
    roi: { multiplier: 2.5, baseLeadsPerMonth: 40, descriptor: "Support" },
  },
];

export const AGENT_BY_ID = Object.fromEntries(AGENTS.map((a) => [a.id, a]));
